import React from 'react';
import { Zap } from 'lucide-react';

const Footer: React.FC = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="relative z-10 border-t border-slate-800 bg-black/40 backdrop-blur-sm">
            {/* Mobile-only: 10 Free Credits badge (moved from header) */}
            <div className="md:hidden flex justify-center pt-6 pb-2">
                <div className="flex items-center gap-1.5 px-3 py-2 bg-orange-900/30 rounded-full border-2 border-orange-500/50 shadow-md shadow-orange-500/20">
                    <Zap size={14} className="text-orange-400 fill-orange-400 shrink-0" />
                    <span className="font-bold text-orange-200 text-xs whitespace-nowrap">10 Free Credits</span>
                </div>
            </div>
            <div className="container mx-auto px-4 py-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    {/* Brand */}
                    <div className="md:col-span-1">
                        <div className="mb-3">
                            <img src="/360tours-studio-logo-transparent.png" alt="360 Tours Studio" className="h-14 sm:h-16 w-auto max-w-[240px] object-contain" />
                        </div>
                        <p className="text-xs text-slate-500 leading-relaxed">
                            Create stunning 360° virtual tours with interactive hotspots, custom branding and analytics.
                        </p>
                    </div>

                    {/* Product */}
                    <div>
                        <h4 className="text-xs font-semibold text-orange-400 uppercase tracking-wider mb-3">Product</h4>
                        <ul className="space-y-2 text-xs text-slate-500">
                            <li>360° Virtual Tours</li>
                            <li>Interactive Hotspots</li>
                            <li>Custom Branding</li>
                            <li>Tour Analytics</li>
                            <li>Floor Plans & Maps</li>
                        </ul>
                    </div>

                    {/* Pricing */}
                    <div>
                        <h4 className="text-xs font-semibold text-orange-400 uppercase tracking-wider mb-3">Pricing</h4>
                        <ul className="space-y-2 text-xs text-slate-500">
                            <li className="flex items-center gap-1.5">
                                <span className="w-1.5 h-1.5 bg-green-400 rounded-full" />
                                Build & preview free
                            </li>
                            <li>7 Days — 2 credits</li>
                            <li>30 Days — 3 credits</li>
                            <li>6 Months — 6 credits</li>
                            <li>12 Months — 10 credits</li>
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h4 className="text-xs font-semibold text-orange-400 uppercase tracking-wider mb-3">Company</h4>
                        <ul className="space-y-2 text-xs text-slate-500">
                            <li>
                                <a href="/how-to-capture-a-property-for-a-virtual-tour" className="hover:text-orange-400 transition-colors">
                                    How to Capture a Property
                                </a>
                            </li>
                            <li>
                                <a href="/recommended-360-cameras" className="hover:text-orange-400 transition-colors">
                                    Recommended Cameras
                                </a>
                            </li>
                            <li>
                                <a href="https://hub.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors">
                                    ReHub Studio
                                </a>
                            </li>
                            <li>
                                <a href="https://hub.rehub.studio/#/partner" className="hover:text-orange-400 transition-colors">
                                    Partner Programme
                                </a>
                            </li>
                            <li>
                                <a href="https://photoclear.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors">
                                    Photoclear
                                </a>
                            </li>
                            <li>
                                <a href="https://hub.rehub.studio/#/contact" className="hover:text-orange-400 transition-colors">
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="pt-6 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-[11px] text-slate-600">
                        © {year} ReHub Studio. All rights reserved.
                    </p>
                    <div className="flex items-center gap-4 text-[11px] text-slate-600">
                        <span>Part of the ReHub Suite</span>
                        <span className="text-slate-700">·</span>
                        <span>10 free credits on signup</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
